(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bendito-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bendito-quick-add')) {
    class BenditoQuickAdd extends HTMLElement {
      connectedCallback() {
        // Se mueve dentro de la foto del producto para quedar encima de la imagen
        const gallery = this.closest('.mixed-grid__item')?.querySelector('.card-gallery');
        if (gallery && this.parentElement !== gallery) {
          gallery.appendChild(this);
          return;
        }

        if (this.dataset.ready) return;
        this.dataset.ready = 'true';

        this.variants = JSON.parse(this.querySelector('.bqa__variants')?.textContent || '[]');
        this.toggle = this.querySelector('.bqa__toggle');
        this.panel = this.querySelector('.bqa__panel');
        this.status = this.querySelector('.bqa__status');

        this.addEventListener('click', this.onClick);
        this.panel?.addEventListener('click', this.onClick);
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.updateAvailability();
      }

      disconnectedCallback() {
        if (this.panel?.classList.contains('bqa__panel--sheet')) {
          this.panel.remove();
          this.backdrop?.remove();
        }
        document.removeEventListener('click', this.onOutsideClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      onClick = (event) => {
        if (event.currentTarget === this && this.panel?.contains(event.target)) return;
        const target = event.target.closest('button');
        if (!target || !(this.contains(target) || this.panel?.contains(target))) return;
        event.preventDefault();
        event.stopPropagation();

        if (target === this.toggle) {
          if (this.dataset.single === 'true') {
            this.add(this.variants[0], target);
          } else {
            this.open();
          }
          return;
        }

        if (target.classList.contains('bqa__close')) {
          this.close();
          return;
        }

        if (target.classList.contains('bqa__value')) {
          const row = target.closest('.bqa__row');
          if (row.classList.contains('bqa__row--final')) {
            const variant = this.findVariant(target.dataset.value);
            if (variant) this.add(variant, target);
          } else {
            row.querySelectorAll('.bqa__value').forEach((button) => {
              button.setAttribute('aria-pressed', String(button === target));
            });
            this.updateAvailability();
          }
        }
      };

      selectedOptions() {
        return [...this.panel.querySelectorAll('.bqa__row:not(.bqa__row--final)')].map(
          (row) => row.querySelector('.bqa__value[aria-pressed="true"]')?.dataset.value
        );
      }

      findVariant(lastValue) {
        const wanted = [...this.selectedOptions(), lastValue];
        return this.variants.find((variant) => wanted.every((value, index) => variant.options[index] === value));
      }

      updateAvailability() {
        this.panel?.querySelectorAll('.bqa__row--final .bqa__value').forEach((button) => {
          const variant = this.findVariant(button.dataset.value);
          button.disabled = !variant || !variant.available;
        });
      }

      open() {
        if (!this.panel) return;
        document.querySelectorAll('bendito-quick-add.bqa--open').forEach((other) => other !== this && other.close());

        if (this.mobile.matches) {
          // En celular el cuadro se va al final de la página para salir fijo abajo de la pantalla
          this.backdrop = document.createElement('div');
          this.backdrop.className = 'bqa-backdrop';
          this.backdrop.addEventListener('click', () => this.close());
          document.body.append(this.backdrop, this.panel);
          this.panel.classList.add('bqa__panel--sheet');
          this.panel.style.setProperty('--bqa-bottom-offset', `${this.bottomBarHeight()}px`);
        }

        this.panel.hidden = false;
        this.classList.add('bqa--open');
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            this.panel.classList.add('is-open');
            this.backdrop?.classList.add('is-open');
          })
        );
        this.toggle.setAttribute('aria-expanded', 'true');
        setTimeout(() => document.addEventListener('click', this.onOutsideClick));
        document.addEventListener('keydown', this.onKeydown);
        this.panel.querySelector('.bqa__row--final .bqa__value:not(:disabled)')?.focus({ preventScroll: true });
      }

      close() {
        if (!this.panel) return;
        this.classList.remove('bqa--open');
        this.panel.classList.remove('is-open');
        const backdrop = this.backdrop;
        this.backdrop = null;
        backdrop?.classList.remove('is-open');
        this.toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onOutsideClick);
        document.removeEventListener('keydown', this.onKeydown);
        setTimeout(() => {
          backdrop?.remove();
          if (this.classList.contains('bqa--open')) return;
          this.panel.hidden = true;
          if (this.panel.classList.contains('bqa__panel--sheet')) {
            this.panel.classList.remove('bqa__panel--sheet');
            this.append(this.panel);
          }
          if (this.status) this.status.textContent = '';
        }, 300);
      }

      // Barra fija de abajo (por ejemplo la de vista previa de Shopify) que taparía las tallas
      bottomBarHeight() {
        let height = 0;
        document.querySelectorAll('#PBarNextFrameWrapper, iframe[id^="PBar"], #preview-bar-iframe').forEach((bar) => {
          const box = bar.getBoundingClientRect();
          if (box.height && box.bottom >= window.innerHeight - 2) height = Math.max(height, window.innerHeight - box.top);
        });
        return Math.min(height, 160);
      }

      onOutsideClick = (event) => {
        if (!this.contains(event.target) && !this.panel.contains(event.target)) this.close();
      };

      onKeydown = (event) => {
        if (event.key === 'Escape') {
          this.close();
          this.toggle.focus();
        }
      };

      async add(variant, button) {
        if (!variant || this.busy) return;
        this.busy = true;
        button.setAttribute('data-loading', '');
        if (this.status) this.status.textContent = 'Agregando…';

        try {
          const root = window.Shopify?.routes?.root || '/';
          const sectionIds = [...document.querySelectorAll('cart-items-component')]
            .map((element) => element.dataset.sectionId)
            .filter(Boolean);

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variant.id, quantity: 1 }],
              sections: sectionIds.join(','),
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar');

          if (this.status) this.status.textContent = 'Agregado al carrito ✓';
          this.classList.add('bqa--added');
          setTimeout(() => this.classList.remove('bqa--added'), 1400);

          const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
          this.close();
          await this.announceCartUpdate(variant, cart, data.sections);
        } catch (error) {
          if (this.status) this.status.textContent = error.message;
        } finally {
          this.busy = false;
          button.removeAttribute('data-loading');
        }
      }

      // Avisa al tema (Horizon) que se agregó un producto: actualiza el carrito, el contador y abre el cajón
      async announceCartUpdate(variant, cart, sections) {
        try {
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          const deferred = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(variant.id), quantity: 1 }],
              promise: deferred.promise,
            })
          );
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'bendito-quick-add',
              itemCount: 1,
              sections,
              didError: false,
            },
          });
        } catch (_) {
          // Si el tema no tiene esos eventos, al menos se actualiza el contador y se abre el cajón
          document.querySelectorAll('cart-icon').forEach((icon) => icon.renderCartBubble?.(cart.item_count));
          document.getElementById('cart-drawer')?.open?.();
        }

        setTimeout(() => {
          const drawer = document.getElementById('cart-drawer');
          if (drawer && !drawer.hasAttribute('open')) drawer.open?.();
        }, 600);
      }
    }

    customElements.define('bendito-quick-add', BenditoQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

})();
